import React, { Component } from "react";
import { DialogInput, DialogButton } from "../Modal/Modal";
import {
  GET_RECORD_HAS_ACTIVE_PIN,
  REQUEST_NEW_PIN,
  GET_WEB_USER_ACCESS_WITH_PIN
} from "../../requests";
import { Spinner } from "../Loaders/Loaders";
import { getSourceTypeId } from 'utilities'
import ReactMarkdown from 'components/Markdown/Markdown'
import { Checkbox } from 'components/Wizard2/fieldComponents/Form'
import { InRouteRedirector } from 'components/LoginRedirector/LoginRedirector'
import { SUBROUTES_OBJ } from '../../App'

const PIN_REQUEST_ATTESTATIONS = process.env.PIN_REQUEST_ATTESTATIONS;
const PIN_REQUEST_SUCCESS_MESSAGE = process.env.PIN_REQUEST_SUCCESS_MESSAGE;
const PIN_SWAP_ON_SUCCESS = process.env.PIN_SWAP_ON_SUCCESS !== undefined ? process.env.PIN_SWAP_ON_SUCCESS : true;

export default class Pins extends Component {
  constructor() {
    super();
    this.state = {
      recordHasActivePin: null,
      pinRequestSuccessful: null,
      pinCorrect: null,
      error: null
    };
  }
  componentDidMount = () => {
    this.getNumActivePins();
  };
  getNumActivePins = () => {
    GET_RECORD_HAS_ACTIVE_PIN(
      this.props.category,
      this.props.source_id,
      recordHasActivePin => {
        this.setState({ recordHasActivePin });
      }
    );
  };
  checkPin = () => {
    const SOURCE_TYPE_ID = getSourceTypeId(this.props.category);
    GET_WEB_USER_ACCESS_WITH_PIN(
      {
        PIN_NUM: this.pinSection.getValue().value,
        SOURCE_TYPE_ID,
        SOURCE_ID: this.props.source_id
      },
      accepted => {
        if (accepted) {
          if(PIN_SWAP_ON_SUCCESS){
            this.props.onPinSuccess();
          }else{
            this.setState({ pinCorrect: true });
          }
        } else {
          this.setState({ pinCorrect: false });
        }
      }
    );
  };
  requestPin = () => {
    REQUEST_NEW_PIN(
      this.props.category,
      this.props.source_id,
      success => {
        this.setState({ pinRequestSuccessful: success });
        this.getNumActivePins();
      },
      err => {
        console.error(err);
        this.setState({
          error:
            "Something went wrong. Please try again later, and if the problem persists please contact customer support."
        });
      }
    );
  };
  redirectToPinInput = () => {
    this.setState({pinRequestSuccessful: null})
  }
  render() {
    // console.log(SUBROUTES_OBJ[this.props.category]);

    return (
      <div className="request-pins">
        <InRouteRedirector/>
        {this.state.recordHasActivePin !== null ||
        this.state.recordHasActivePin !== undefined ? (
          this.state.recordHasActivePin === true ||
          this.state.pinRequestSuccessful ? (
            <div>
              {this.state.pinRequestSuccessful === true && (
                <React.Fragment>
                  <p>
                    {
                      PIN_REQUEST_SUCCESS_MESSAGE ? PIN_REQUEST_SUCCESS_MESSAGE : `We've sent a new pin to the entity's mailing address on file. When it arrives, return to this page and input your PIN using the Request Access function to gain access to this record.`
                    }
                  </p>
                  <div className="row">
                    <div className="col-12 button-column">
                      <DialogButton
                        label="Input PIN Now"
                        className="btn-raised"
                        customClickHandler
                        onClick={this.redirectToPinInput}
                      />
                    </div>
                  </div>
                </React.Fragment>
              )}
              {this.state.pinRequestSuccessful === null && (
                <PinInputSection
                  ref={pinSection => {
                    this.pinSection = pinSection;
                  }}
                  onCheckPinRequest={this.checkPin}
                  error={
                    this.state.pinCorrect === false
                      ? "Sorry, the PIN you entered is not associated with this record."
                      : null
                  }
                  pinAccepted={this.state.pinCorrect === true}
                  onRequestModalClose={this.props.onRequestModalClose}
                  config={SUBROUTES_OBJ[this.props.category]}
                />
              )}
            </div>
          ) : (
            this.state.pinRequestSuccessful !== true && (
              <PinRequestSection
                description={`Click **Request PIN** to have a new PIN sent to the ${PIN_REQUEST_ATTESTATIONS ? "account holder's email" : "record's mailing"} address on file.`}
                onPinRequest={this.requestPin}
                error={this.state.error}
                config={SUBROUTES_OBJ[this.props.category]}
              />
            )
          )
        ) : (
          <div className="loader-wrapper">
            <Spinner themeColor="medium-neutral" size="small" />
          </div>
        )}
      </div>
    );
  }
}

export class PinInputSection extends Component {
  state = {
    attestation1Checked: false,
    attestation2: false
  }
  componentDidMount = () => {
    this.pinInput.focus();
  };
  getValue = () => {
    return this.pinInput.getValue();
  };
  resetValue = () => {
    this.pinInput.setValue('');
  }
  setValue = (name, checked) => {
    this.setState({ [name]: checked });
  };
  render() {
    const { onCheckPinRequest, sendValue, error, config, submitDisabled, pinAccepted, onRequestModalClose } = this.props;
    return (
      pinAccepted ?
      <div>
        <p className='success-text flex-center'>
          Your PIN has been accepted.
        </p>
        <div className='flex-center'>
          <button onClick={onRequestModalClose} className='btn btn-raised'>Continue</button>
        </div>
      </div>
      :
      <div className="wizard">
        {PIN_REQUEST_ATTESTATIONS && (
          <div className="row">
            <div className="col-12">
              <p className="attestation-hint">You <strong>must</strong> check both boxes below to proceed</p>
            </div>
          </div>
        )}
        {PIN_REQUEST_ATTESTATIONS && (
          <div className="row">
            <div className="col-12 checkbox-column">
              <Checkbox
                fieldId="attestation1"
                value={this.state.attestation1Checked}
                onChange={checked => {
                  this.setValue("attestation1Checked", checked);
                }}
                label={config.pinInputAttest1Label || "I hereby certify I am authorized to utilize this PIN to associate this business entity to my user account."}
              />
            </div>
          </div>
        )}
        {PIN_REQUEST_ATTESTATIONS && (
          <div className="row">
            <div className="col-12">
              <Checkbox
                fieldId="attestation2"
                value={this.state.attestation2Checked}
                onChange={checked => {
                  this.setValue("attestation2Checked", checked);
                }}
                label={config.pinInputAttest2Label || "I hereby certify the account to which I am a associating this entity is my account, an authorized account for an employee of this entity, or the account of an authorized third party preparer for the entity."}
              />
            </div>
          </div>
        )}
        <div className="row pin-input-section">
          <div className="col-8">
            <DialogInput
              ref={pinInput => {
                this.pinInput = pinInput;
              }}
              submit={e => (
                !PIN_REQUEST_ATTESTATIONS ||
                (this.state.attestation1Checked &&
                  this.state.attestation2Checked)
              ) && (sendValue ? onCheckPinRequest(this.getValue()) : onCheckPinRequest(e))}
              type="text"
              label="Enter PIN"
            />
          </div>
          <div className="col-4 button-column">
            <DialogButton
              disabled={
                submitDisabled ? true :
                !(
                  !PIN_REQUEST_ATTESTATIONS ||
                  (this.state.attestation1Checked &&
                    this.state.attestation2Checked)
                )
              }
              label="Get Access"
              className="btn-raised"
              customClickHandler
              onClick={e => sendValue ? onCheckPinRequest(this.getValue()) : onCheckPinRequest(e)}
            />
          </div>
        </div>
        {error && (
          <div className="error">
            <span className="icon icon-danger" />
            {error}
          </div>
        )}
      </div>
    );
  }
}

class PinRequestSection extends Component {
  state = {
    attestation1Checked: false,
    attestation2Checked: false
  };
  setValue = (name, checked) => {
    this.setState({ [name]: checked });
  };
  render() {
    const { onPinRequest, description, error, config } = this.props;
    return (
      <div className="wizard">
        <div className="row">
          <div className="col-12">
            <ReactMarkdown
              source={description}
              className="center-text pin-description"
            />
          </div>
        </div>
        {PIN_REQUEST_ATTESTATIONS && (
          <div className="row">
            <div className="col-12">
              <p className="attestation-hint">You <strong>must</strong> check both boxes below to proceed</p>
            </div>
          </div>
        )}
        {PIN_REQUEST_ATTESTATIONS && (
          <div className="row">
            <div className="col-12 checkbox-column">
              <Checkbox
                fieldId="attestation1"
                value={this.state.attestation1Checked}
                onChange={checked => {
                  this.setValue("attestation1Checked", checked);
                }}
                label={config.pinRequestAttest1Label || "I hereby certify I am authorized to request access to this account on behalf of the business entity to which this request pertains."}
              />
            </div>
          </div>
        )}
        {PIN_REQUEST_ATTESTATIONS && (
          <div className="row">
            <div className="col-12">
              <Checkbox
                fieldId="attestation2"
                value={this.state.attestation2Checked}
                onChange={checked => {
                  this.setValue("attestation2Checked", checked);
                }}
                label={config.pinRequestAttest2Label || "I hereby certify the account from which I am requesting access to this entity is my account, an authorized account for an employee of this entity, or the account of an authorized third party preparer for the entity."}
              />
            </div>
          </div>
        )}
        <div className="row margin-top">
          <div className="col-12 button-column">
            <DialogButton
              disabled={
                !(
                  !PIN_REQUEST_ATTESTATIONS ||
                  (this.state.attestation1Checked &&
                    this.state.attestation2Checked)
                )
              }
              label="Request PIN"
              className="btn-raised"
              customClickHandler
              onClick={onPinRequest}
            />
          </div>
        </div>
        {error && <p className="error">{error}</p>}
      </div>
    );
  }
}
